module.exports = __webpack_public_path__ + "img/effect-2.ada061e3.jpg";